import { Avatar, Box, Button, IconButton, TextField, Typography } from '@mui/material';
import ThumbUpIcon from '@mui/icons-material/ThumbUp';
import ThumbDownIcon from '@mui/icons-material/ThumbDown';
import ReplyIcon from '@mui/icons-material/Reply';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';

const ComentarioCard = ({
    comentario,
    isExpanded,
    onToggle,
    isOwner,
    isLoggedIn,
    hasLiked,
    hasDisliked,
    onLike,
    onDislike,
    onReply,
    onEditClick,
    onDelete,
    isEditing,
    editContent,
    onChangeEditContent,
    onSaveEdit,
    onCancelEdit,
    maxCommentLength,
    formattedDate,
    replyingTo,
}) => {
    const handleRootClick = () => {
        if (!isEditing) {
            onToggle();
        }
    };

    return (
        <Box
            onClick={handleRootClick}
            sx={{
                display: 'flex',
                gap: 0.5,
                alignItems: 'flex-start',
                p: 0.5,
                borderRadius: 1,
                cursor: isEditing ? 'default' : 'pointer',
                transition: 'background-color 0.2s ease',
            }}
        >
            <Avatar
                src={comentario.account?.image}
                sx={{
                    bgcolor: 'error.main',
                    width: 30,
                    height: 30,
                }}
            >
                {comentario.account?.nickname?.[0]?.toUpperCase()}
            </Avatar>

            <Box sx={{ flex: 1, width: '100%' }}>
                <Box
                    sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 0.25 }}
                >
                    <Typography variant="subtitle2" fontWeight={500} fontSize={12}>
                        {comentario.account?.nickname || 'Usuario'}
                    </Typography>

                    {isExpanded && isOwner && (
                        <Box sx={{ display: 'flex', gap: 0.5 }} onClick={(e) => e.stopPropagation()}>
                            <IconButton
                                size="small"
                                onClick={onEditClick}
                                title="Editar comentario"
                                sx={{
                                    color: 'text.secondary',
                                    opacity: 0.6,
                                    '&:hover': {
                                        opacity: 1,
                                        color: 'primary.main',
                                    },
                                }}
                            >
                                <EditIcon fontSize="small" />
                            </IconButton>
                            <IconButton
                                size="small"
                                onClick={onDelete}
                                title="Eliminar comentario"
                                sx={{
                                    color: 'text.secondary',
                                    opacity: 0.6,
                                    '&:hover': {
                                        opacity: 1,
                                        color: 'error.main',
                                    },
                                }}
                            >
                                <DeleteIcon fontSize="small" />
                            </IconButton>
                        </Box>
                    )}
                </Box>

                {isEditing ? (
                    <Box sx={{ mb: 1 }} onClick={(e) => e.stopPropagation()}>
                        <TextField
                            fullWidth
                            multiline
                            minRows={2}
                            maxRows={8}
                            value={editContent}
                            onChange={(e) => onChangeEditContent(e.target.value)}
                            variant="outlined"
                            size="small"
                            sx={{ mb: 0.5 }}
                        />
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                flexWrap: 'wrap',
                                gap: 1,
                            }}
                        >
                            <Typography
                                sx={{
                                    fontSize: '11px',
                                    color:
                                        editContent.length > maxCommentLength - 20
                                            ? 'error.main'
                                            : 'text.secondary',
                                }}
                            >
                                {editContent.length}/{maxCommentLength}
                            </Typography>
                            <Box sx={{ display: 'flex', gap: 1 }}>
                                <Button
                                    size="small"
                                    variant="contained"
                                    onClick={onSaveEdit}
                                    disabled={!editContent.trim() || editContent.length > maxCommentLength}
                                >
                                    Guardar
                                </Button>
                                <Button size="small" variant="outlined" onClick={onCancelEdit}>
                                    Cancelar
                                </Button>
                            </Box>
                        </Box>
                    </Box>
                ) : (
                    <Typography
                        variant="body2"
                        sx={{
                            fontSize: '12px',
                            whiteSpace: isExpanded ? 'pre-wrap' : 'nowrap',
                            wordBreak: 'break-word',
                            overflowWrap: 'break-word',
                            overflow: isExpanded ? 'visible' : 'hidden',
                            textOverflow: isExpanded ? 'unset' : 'ellipsis',
                            color: 'text.primary',
                            maxWidth: isExpanded ? '100%' : '100%',
                            display: isExpanded ? 'block' : 'block',
                        }}
                    >
                        {replyingTo && (
                            <Typography
                                component="span"
                                sx={{
                                    color: 'primary.main',
                                    fontWeight: 'bold',
                                    mr: 0.5,
                                }}
                            >
                                @{replyingTo}
                            </Typography>
                        )}
                        <span
                            style={{
                                whiteSpace: isExpanded ? 'pre-wrap' : 'nowrap',
                                textOverflow: isExpanded ? 'unset' : 'ellipsis',
                                overflow: isExpanded ? 'visible' : 'hidden',
                                display: 'inline-block',
                                maxWidth: isExpanded ? '100%' : '90%',
                            }}
                        >
                            {comentario.content}
                        </span>
                    </Typography>
                )}

                {isExpanded && !isEditing && (
                    <Box sx={{ mt: 1 }} onClick={(e) => e.stopPropagation()}>
                        <Box
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                gap: 1,
                                mb: 1,
                            }}
                        >
                            {isLoggedIn && (
                                <Button
                                    size="small"
                                    startIcon={<ReplyIcon />}
                                    onClick={onReply}
                                    sx={{
                                        textTransform: 'none',
                                        minWidth: 'auto',
                                    }}
                                >
                                    Responder
                                </Button>
                            )}
                            <Typography variant="caption" fontSize={12} color="text.secondary">
                                {formattedDate}
                            </Typography>
                        </Box>
                    </Box>
                )}
            </Box>
        </Box>
    );
};

export default ComentarioCard;
